/**
 * Created by pzf on 19/9/1.
 *
 */
import PropTypes from 'prop-types';
import noop from '../_util/noop'; // 公共部分

export var propTypes = {
  prefixCls: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.array,
  onClick: PropTypes.func,
  render: PropTypes.func,
  maxSize: PropTypes.number,
  showLabel: PropTypes.bool
}; // 公共部分

export var defaultPropTypes = {
  prefixCls: 'mkui-tags-select',
  placeholder: '',
  onClick: noop,
  disabled: false,
  multiple: false,
  label: '',
  value: [],
  maxSize: 10,
  render: null,
  showLabel: true
};
//# sourceMappingURL=PropTypes.js.map
